import { useState, useEffect, useCallback } from 'react';

const STORAGE_KEY = 'ninjathlete_recently_viewed_products';
const MAX_ITEMS = 10;

export function useRecentlyViewedProducts() {
  const [products, setProducts] = useState([]);

  useEffect(() => {
    try {
      const stored = JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]');
      setProducts(stored);
    } catch { setProducts([]); }
  }, []);

  const trackView = useCallback((product) => {
    if (!product?.id) return;
    try {
      const stored = JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]');
      const filtered = stored.filter(p => p.id !== product.id);
      const entry = {
        id: product.id,
        slug: product.slug,
        name: product.name,
        price: product.price,
        compare_at_price: product.compare_at_price,
        image: product.images?.[0] || '',
        category: product.category,
        viewedAt: Date.now(),
      };
      const updated = [entry, ...filtered].slice(0, MAX_ITEMS);
      localStorage.setItem(STORAGE_KEY, JSON.stringify(updated));
      setProducts(updated);
    } catch { /* silent */ }
  }, []);

  const getExcluding = useCallback((excludeId) => {
    return products.filter(p => p.id !== excludeId);
  }, [products]);

  return { products, trackView, getExcluding };
}
